module.exports = __webpack_public_path__ + "static/media/uirusu.cabee64d.PNG";